export default __webpack_public_path__ + "static/alexgo-4aa15b79023df7b50f2abda34ef45db1.svg";